import React from 'react';
import { Radio, Smartphone, Globe } from 'lucide-react';

const HowItWorks = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Two tracking modes for complete visibility
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* ON-CAMPUS */}
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 shadow-lg border-2 border-blue-200">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-blue-900 flex items-center justify-center">
                <Radio className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">ON-CAMPUS TRACKING</h3>
            </div>

            <div className="space-y-4 mb-8">
              {[
                'E2 network with BLE technology',
                'BLE tags + repeaters + relays',
                'No SIM cards, no GPS needed',
                'Real-time on-site visibility',
                'Inter-site tracking between facilities',
              ].map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-blue-900 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-white text-xs font-bold">✓</span>
                  </div>
                  <p className="text-gray-700 font-medium">{feature}</p>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-2 gap-4">
              <img 
                src="https://images.unsplash.com/photo-1644079446600-219068676743"
                alt="Warehouse interior"
                className="rounded-lg shadow-md w-full h-32 object-cover"
              />
              <img 
                src="https://images.unsplash.com/photo-1732247429548-ede5fbfee3f0"
                alt="IoT repeaters"
                className="rounded-lg shadow-md w-full h-32 object-cover"
              />
            </div>
          </div>

          {/* OFF-CAMPUS */}
          <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-2xl p-8 shadow-lg border-2 border-red-200">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-red-600 flex items-center justify-center">
                <Globe className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">OFF-CAMPUS TRACKING</h3>
            </div>

            <div className="space-y-4 mb-8">
              <div className="bg-white rounded-lg p-4 border-l-4 border-red-600">
                <p className="font-semibold text-gray-900 mb-2">Option 1: Battery-Powered E2 Relay</p>
                <p className="text-gray-600 text-sm">Ship a portable relay with your assets to maintain E2 network connectivity</p>
              </div>
              
              <div className="bg-white rounded-lg p-4 border-l-4 border-red-600">
                <p className="font-semibold text-gray-900 mb-2">Option 2: GPS + GSM Tracking</p>
                <p className="text-gray-600 text-sm">Use GPS trackers for high-value shipments requiring long-range tracking</p>
              </div>

              <div className="flex items-start gap-3 mt-4">
                <Smartphone className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
                <p className="text-gray-700 font-medium">Works seamlessly with external logistics partners</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <img 
                src="https://images.unsplash.com/photo-1692959269682-7795401d4100"
                alt="Shipping dock"
                className="rounded-lg shadow-md w-full h-32 object-cover"
              />
              <img 
                src="https://images.unsplash.com/photo-1625217527288-93919c99650a"
                alt="GPS tracking"
                className="rounded-lg shadow-md w-full h-32 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
